import React, { useContext } from 'react';
import styled from '@emotion/styled';
import { DTOUserSearchResultItem } from '../../generated-common';
import { SelectValueLabel, UserWithAvatar } from '../../components/ui/UserWithAvatar';
import Spinner from '@atlaskit/spinner';
import EmptyState from '@atlaskit/empty-state';
import { GlobalContext } from '../../shared-components/common/GlobalContext';
import { token } from '@atlaskit/tokens';

const UserWrapper = styled.div`
  margin-top: 5px;
`;

const User = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px;
  &:hover {
    background-color: ${token('color.background.neutral.subtle.pressed', '#efefef')};
  }
`;

export const PermissionEditorSetAndGetPermissionsUserList = ({
  isFetching,
  isMutating,
  users,
  onDeleteClick,
}: {
  isFetching: boolean;
  isMutating: boolean;
  users: DTOUserSearchResultItem[];
  onDeleteClick: (group: string) => void;
}) => {
  const { t } = useContext(GlobalContext);

  return (
    <UserWrapper>
      <div style={{ height: '20px', minHeight: '20px', maxHeight: '20px' }}>{(isFetching || isMutating) && <Spinner size="small" />}</div>
      {!isFetching && !isMutating && (!users || users.length === 0) && (
        <>
          <EmptyState header={t('editPermissionsPage.emptyMessage.userTitle')} description={t('editPermissionsPage.emptyMessage.userDescription')} />
        </>
      )}
      {users && users.length > 0 && (
        <>
          {users.map((u, ind) => (
            <User key={ind}>
              <UserWithAvatar
                user={{ value: u.accountId, label: '', displayName: u.displayName, avatar: u.avatarUrl }}
                index={ind}
                onDelete={(_delIndex: number, delValue: SelectValueLabel) => {
                  if (delValue && delValue.value) {
                    onDeleteClick(delValue.value);
                  }
                }}
                isReadOnly={false}
                isDisabled={isMutating || isFetching}
                parentWidth={400}
              />
            </User>
          ))}
        </>
      )}
    </UserWrapper>
  );
};
